import { IPlaneringsstatusFilter } from "./IPlaneringsstatusFilter";

export class PlaneringsstatusFilter implements IPlaneringsstatusFilter {
    underPlanering: boolean;
    fardigplanerad: boolean;
    tillganglig: boolean;
}
